var map = {
	"./chevron-left.svg": 635,
	"./chevron-right.svg": 636,
	"./facebook.svg": 637,
	"./instagram.svg": 638,
	"./loading.svg": 639,
	"./menu.svg": 640,
	"./spinner.svg": 641,
	"./trash.svg": 642,
	"./upload.svg": 643,
	"./xlsx-file.svg": 644,
	"./youtube.svg": 645
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1232;



//////////////////
// WEBPACK FOOTER
// ./src/images/icons ^\.\/.*\.svg$
// module id = 1232
// module chunks = 0